document.addEventListener('DOMContentLoaded', function () {
    const galleryItems = document.querySelectorAll('.ceps-main-media-item');
    const thumbs = document.querySelectorAll('.ceps-thumb-btn');
    const modal = document.getElementById('ProductMediaModal');
    const modalImg = document.getElementById('ModalImage');

    if (!galleryItems.length || !modal || !modalImg) return;

    const closeBtn = modal.querySelector('.media-close');
    const prevBtn = modal.querySelector('.media-prev');
    const nextBtn = modal.querySelector('.media-next');
    const zoomBtn = document.getElementById('MediaZoomBtn');
    const mediaStage = modal.querySelector('.media-stage');
    const currentCounter = document.getElementById('CurrentMediaIndex');

    let currentIndex = 0;
    let isZoomed = false;

    function getVisibleItems() {
        return Array.from(galleryItems).filter(item => item.style.display !== 'none');
    }

    function updateCounter() {
        if (!currentCounter) return;

        const visibleItems = getVisibleItems();
        const currentVisibleIndex = visibleItems.indexOf(galleryItems[currentIndex]);

        currentCounter.textContent = `${currentVisibleIndex + 1} / ${visibleItems.length}`;
    }

    function updateActiveThumb() {
        thumbs.forEach((thumb) => {
            thumb.classList.remove('is-active');

            const thumbIndex = parseInt(thumb.dataset.index, 10);

            if (thumbIndex === currentIndex) {
                thumb.classList.add('is-active');
            }
        });
    }

    function showLoader(show = true) {
        mediaStage.classList.toggle('loading', show);
    }

    function updateModalImage() {
        const item = galleryItems[currentIndex];

        if (!item) return;

        showLoader(true);

        const newImg = new Image();

        newImg.onload = function () {
            modalImg.src = item.dataset.full;
            modalImg.alt = item.dataset.alt || '';

            updateCounter();
            updateActiveThumb();
            resetZoom();

            showLoader(false);
        };

        newImg.src = item.dataset.full;
    }

    function openModal(index = 0) {
        currentIndex = index;

        updateModalImage();

        modal.classList.add('active');
        modal.setAttribute('aria-hidden', 'false');

        document.body.classList.add('modal-open');
    }

    function closeModal() {
        modal.classList.remove('active');
        modal.setAttribute('aria-hidden', 'true');

        document.body.classList.remove('modal-open');

        resetZoom();
    }

    function nextImage() {
        const visibleItems = getVisibleItems();

        if (visibleItems.length <= 1) return;

        let currentVisibleIndex = visibleItems.indexOf(
            galleryItems[currentIndex]
        );

        currentVisibleIndex =
            (currentVisibleIndex + 1) % visibleItems.length;

        currentIndex = Array.from(galleryItems).indexOf(
            visibleItems[currentVisibleIndex]
        );

        updateModalImage();
    }

    function prevImage() {
        const visibleItems = getVisibleItems();

        if (visibleItems.length <= 1) return;

        let currentVisibleIndex = visibleItems.indexOf(
            galleryItems[currentIndex]
        );

        currentVisibleIndex =
            (currentVisibleIndex - 1 + visibleItems.length) %
            visibleItems.length;

        currentIndex = Array.from(galleryItems).indexOf(
            visibleItems[currentVisibleIndex]
        );

        updateModalImage();
    }

    function toggleZoom() {
        isZoomed = !isZoomed;

        modalImg.classList.toggle('zoomed', isZoomed);

        if (zoomBtn) {
            zoomBtn.innerHTML = isZoomed ? '−' : '+';
        }
    }

    function resetZoom() {
        isZoomed = false;

        modalImg.classList.remove('zoomed');

        if (zoomBtn) {
            zoomBtn.innerHTML = '+';
        }
    }

    galleryItems.forEach((item) => {
        item.addEventListener('click', function (event) {
            event.preventDefault();

            currentIndex = Array.from(galleryItems).indexOf(item);

            openModal(currentIndex);
        });
    });

    if (nextBtn) {
        nextBtn.addEventListener('click', nextImage);
    }

    if (prevBtn) {
        prevBtn.addEventListener('click', prevImage);
    }

    if (closeBtn) {
        closeBtn.addEventListener('click', closeModal);
    }

    if (zoomBtn) {
        zoomBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            toggleZoom();
        });
    }

    modalImg.addEventListener('click', function (e) {
        e.stopPropagation();
        toggleZoom();
    });

    modal.addEventListener('click', function (e) {
        if (e.target === modal) {
            closeModal();
        }
    });

    document.addEventListener('keydown', function (e) {
        if (!modal.classList.contains('active')) return;

        switch (e.key) {
            case 'Escape':
                closeModal();
                break;

            case 'ArrowRight':
                nextImage();
                break;

            case 'ArrowLeft':
                prevImage();
                break;
        }
    });

    let touchStartX = 0;
    let touchEndX = 0;

    modal.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    modal.addEventListener('touchend', function (e) {
        touchEndX = e.changedTouches[0].screenX;

        const swipeDistance = touchStartX - touchEndX;

        if (Math.abs(swipeDistance) > 50) {
            if (swipeDistance > 0) {
                nextImage();
            } else {
                prevImage();
            }
        }
    }, { passive: true });
});
